import { render, staticRenderFns } from "./UserRemovedFromDepartment.vue?vue&type=template&id=7c25de04&scoped=true"
import script from "./UserRemovedFromDepartment.vue?vue&type=script&lang=js"
export * from "./UserRemovedFromDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25de04",
  null
  
)

export default component.exports